import { gql } from '@apollo/client';
import { Checkbox, Form, Input, Space, message } from 'antd';
import Modal from 'components/Modal';
import { useMutation } from 'hooks/apollo';
import React, { useEffect } from 'react';
import FormLabel from 'components/FormLabel';
import messages from '../messages';

const CREATE_WEBSITE_CHECK = gql`
  mutation CreateWebsiteCheck($websiteId: ID!, $input: WebsiteCheckInput!) {
    createWebsiteCheck(websiteId: $websiteId, input: $input) {
      id
    }
  }
`;

const CheckWebsiteUrl = ({ website, open, onCancel, onDone }) => {
  const [form] = Form.useForm();
  const [checkWebsiteLinks, { loading }] = useMutation(CREATE_WEBSITE_CHECK);

  const urlValidator = async (rule, value) => {
    if (value) {
      if (!value.startsWith(website.url)) {
        throw new Error();
      }
    }
  };

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open]);

  const onFinish = async (values) => {
    try {
      const excludedUrls = [];

      if (values.excludeJs) {
        excludedUrls.push('\\.js$');
      }
      if (values.excludeCss) {
        excludedUrls.push('\\.css$');
      }
      const input = { excludedUrls, url: values.url, recursive: values.recursive };
      console.log('input= ', input);

      await checkWebsiteLinks({ variables: { websiteId: website.id, input } });
    } catch (e) {
      message.error(e.message);
    }
    onDone();
  };

  return (
    <Modal
      title="Check website page"
      open={open}
      onCancel={onCancel}
      onOk={form.submit}
      confirmLoading={loading}
      okText="Run check"
    >
      {website && (
        <Form form={form} onFinish={onFinish} layout="vertical" initialValues={{ url: website.url }}>
          <Form.Item name="url" label="URL" rules={[{ required: true }, { validator: urlValidator, message: `Url must start with the website url (${website.url})` }]}>
            <Input />
          </Form.Item>

          <Form.Item name="recursive" valuePropName="checked">
            <Space>
              <Checkbox />
              <FormLabel label={messages.recursive} description={messages.recursiveDescription} />
            </Space>
          </Form.Item>

          <Form.Item label={<FormLabel label={messages.excludeResources} description={messages.excludeResourcesDescription} />}>
            <Space>
              <Form.Item name="excludeJs" valuePropName="checked">
                <Checkbox> Javascript </Checkbox>
              </Form.Item>

              <Form.Item name="excludeCss" valuePropName="checked">
                <Checkbox> Stylesheet </Checkbox>
              </Form.Item>
            </Space>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default CheckWebsiteUrl;
